let resolveUrl;
let rejectUrl;
const colorsPromise = new Promise((resolve, reject) => {
  resolveUrl = resolve;
  rejectUrl = reject;
});

export default colorsPromise;

// Resolves with the URL of the swatch-colors stylesheet. Consumers that render
// inside a shadow root (color-swatch-radio, predictive-search) append their own
// <link> to it, because a document-level stylesheet doesn't cross the boundary.
//
// This used to be handed the CSS as *text* — scraped out of an inline <style>
// in <head> — and wrapped in a blob: URL. Now that the rules live in a real
// asset, the fingerprinted asset_url is passed straight through: no second copy
// of the CSS in the HTML, and the browser caches one shared file.
export const init = (url) => {
  if (url) {
    resolveUrl(url);
  } else {
    rejectUrl("Colors not initialized correctly");
  }
};
